import * as React from "react";
import { useContext } from "react";
import {
  BaseInputTemplateProps,
  InputTemplateRegistry,
} from "@graffer-inc/form-generator";
import {
  InputElementUnion,
  IRepeatableElement,
} from "@graffer-inc/form-schema";
import { SmartApplyViewInputRegistry } from "./smart-apply-view-input-registry";
import { FormContext } from "@graffer-inc/form-generator";

export class SmartApplyDiffInputRegistry implements InputTemplateRegistry {
  constructor(
    private registry: InputTemplateRegistry = new SmartApplyViewInputRegistry(),
  ) {}

  get(
    elem: InputElementUnion,
    repeatable?: IRepeatableElement,
  ): React.ComponentType<BaseInputTemplateProps<any, any, any>> {
    return this.getDiffInput(elem, repeatable);
  }

  private getDiffInput(
    elem: InputElementUnion,
    repeatable?: IRepeatableElement,
  ): React.ComponentType<BaseInputTemplateProps<any, any, any>> {
    const Input = this.registry.get(elem, repeatable);

    const DiffInput: React.ComponentType<
      BaseInputTemplateProps<any, any, any>
    > = (props) => {
      const {
        modificationContext: { detector },
      } = useContext(FormContext);

      if (!detector || detector.checkInput(props.config) === "NOT_CHANGED") {
        return <Input {...props} />;
      }

      const label = detector.getOriginalLabel(props.config);
      return (
        <div className="columns is-marginless">
          <div className="column is-paddingless">
            <p style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
              {!label && <span className="tag is-small">入力なし</span>}
              {Array.isArray(label)
                ? label.map((v, i) => <p key={i}>{v}</p>)
                : label}
            </p>
          </div>
          <div
            className="column is-narrow"
            style={{ paddingTop: 0, paddingBottom: 0 }}
          >
            <i className="fas fa-arrow-right" />
          </div>
          <div className="column is-paddingless">
            {!props.value ||
            (Array.isArray(props.value) && props.value.length === 0) ? (
              <span className="tag is-small">入力なし</span>
            ) : (
              <Input {...props} />
            )}
          </div>
        </div>
      );
    };

    return DiffInput;
  }
}
